export default __webpack_public_path__ + "static/media/Plywwod_Teak.3854a02f.JPG";